<jb-autocomplete
  *ngIf="vm$ | async as vm"
  #jbAutoComplete
  class="bg-white"
  [options]="searchMode !== 4 ? filteredAirports : vm.allAirports"
  [disableFilter]="searchMode !== 4"
  [groups]="vm.groupedAirports"
  [hasDynamicData]="true"
  [shouldFlipVertically]="false"
  [shouldFitToAnchor]="false"
  [minListWidth]="368"
  [label]="vm.label"
  [formControl]="airportControl"
  [modalLinkText]="vm.modalLinkData.label"
  [noMatchFoundCallback]="vm.noMatchFoundCallback"
  [isLegendShown]="vm.isLegendShown"
  (modalLinkClicked)="
    openDialogOrLinkInDropdownSelector(vm.modalLinkData, vm.isMobile)
  "
  (optionSelected)="handleOptionSelected($event)"
  data-qaid="autocomplete-city-selector"
  [partnerAirlineServiceLabel]="vm.legends?.partner?.title ?? null"
  [mintServiceLabel]="vm.legends?.mint?.title ?? null"
>
</jb-autocomplete>
